import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {Popover, PopoverPlacement, PopoverTrigger} from '../popover/popover';
import { Icon } from '../icon/icon';

require('../../../../icons/questioncircleo.svg');
@Component({
  template: require('./popconfirm.html'),
  name: 'wc-popconfirm',
  components: {
    'wc-popover': Popover
    ,'wc-icon':Icon
  }
})

export class PopConfirm extends Vue {
  @Prop()
  placement: PopoverPlacement;
  @Prop()
  message: string;
  @Prop()
  onSelectingYes: () => void;
  @Prop()
  onSelectingNo: () => void;
  @Prop()
  trigger: PopoverTrigger;
  @Prop({
    default: true
  })
  show: boolean;
  showPopover: boolean = true;

  get popoverPlacement() {
    return this.placement || PopoverPlacement.Top;
  }

  get popoverTrigger() {
    return this.trigger || PopoverTrigger.Click;
  }

  OnConfirm() {
    this.showPopover = false;
    this.onSelectingYes.call(this);
  }

  OnCancel() {
    this.showPopover = false;
    this.onSelectingNo.call(this);
  }

  OnShow() {
    this.showPopover = true;
  }
}



// WEBPACK FOOTER //
// node_modules/wc-lib/src/wc-ui/components/popconfirm/popconfirm.ts